import BackToTopButton from 'components/BackToTopButton/BackToTopButton';

export default BackToTopButton;
